export default "__VITE_ASSET__BTWfrtKj__"